export default __webpack_public_path__ + "static/media/star.1cf22738.svg";